import { PageAppSDK } from "@contentful/app-sdk";
import { ModalConfirm, ModalLauncher, Notification, Paragraph } from "@contentful/f36-components";
import { importTranslations, pollJobUntilComplete } from "../../api/backendClient";

export const onImport = (quoteId: number,projectName:string,  sdk: PageAppSDK) => {
  return ModalLauncher.open(({ isShown, onClose }) => {
    return (
      <ModalConfirm
        title="Import translation"
        intent="positive"
        isShown={isShown}
        onCancel={() => {
          onClose(false);
        }}
        onConfirm={() => {
          onClose(true);
        }}
        confirmLabel="Continue"
        cancelLabel="Cancel"
      >
        <Paragraph>
          This action will import the translation back into each target language. This action will overlap any existing
          translation on the corresponding target languages.
        </Paragraph>
      </ModalConfirm>
    );
  }).then(async (result) => {
    if (result === true) {
      try {
        Notification.setDuration(0);
        Notification.info("Submitting import request...");

        // Submit the import job
        const submitResult = await importTranslations(sdk, quoteId, projectName);

        if (!submitResult.success || !submitResult.data?.jobId) {
          throw new Error(submitResult.error || "Failed to submit import request");
        }

        const jobId = submitResult.data.jobId;
        Notification.closeAll();
        Notification.setDuration(0);
        Notification.info("Import request submitted. Processing...");

        // Poll for job completion with progress updates
        const completedJob = await pollJobUntilComplete(jobId, (job) => {
          if (job.status === 'processing') {
            Notification.closeAll();
            Notification.setDuration(0);
            Notification.info(`Importing translations... ${job.progress}%`);
          }
        });

        // Job completed
        Notification.closeAll();
        const importedCount = completedJob.result?.importedCount || 0;
        const failedCount = completedJob.failedCount || 0;

        if (failedCount > 0) {
          Notification.setDuration(60000);
          Notification.warning(`Import completed with ${failedCount} failed item(s). ${importedCount} item(s) imported successfully.`);
        } else {
          Notification.setDuration(60000);
          Notification.success(`The translated content has been imported successfully. ${importedCount} item(s) imported.`);
        }
      } catch (error: any) {
        Notification.closeAll();
        Notification.setDuration(0);
        Notification.error("An error occurred while trying to import the translated content. Details: " + error.message);
        console.error("Import error:", error);
      }
    }
  });
};
